// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  .offer-type__label {
    font-size: ${(props) =>
      props.theme.brandSpecificStyles.SIGNUP_FORM_INTRO.OFFER_TYPE_LABEL_FONT_SIZE};
    padding-top: 4px;
    ::after {
      content: '';
      height: 2px;
      width: 100px;
      background: ${(props) =>
        props.theme.brandSpecificStyles.SIGNUP_FORM_INTRO.OFFER_TYPE_LABEL_BACKGROUND};
      margin: 12px auto 32px;
      display: block;
      @media ${(props) => props.theme.mediaQuery.medium} {
        margin: 16px auto 32px;
      }
    }
  }
  .offer-type-snj__label {
    font-family: ${(props) => props.theme.fonts.tertiaryUrbaneBold};
    font-size: 45px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 1.35px;
    text-align: center;
    color: ${(props) => props.theme.colorPalette.purple['900']};
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 9.5px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 16px 34.1px 12.6px 33.9px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin: 16px 0 9px;
    }
  }
  .snj-flash-content {
    margin: 20px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 20px auto;
      width: ${(props) => (props.isSMS ? '407px' : '350px')};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 20px auto;
      width: ${(props) => (props.isSMS ? '407px' : '350px')};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 20px auto;
      width: 350px;
    }
  }
  .snj-flash-text {
    font-family: ${(props) => props.theme.fonts.tertiaryUrbaneBold};
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: 0.72px;
    text-align: center;
    color: ${(props) => props.theme.colorPalette.purple['900']};
  }
  .desc-text-snj {
    margin: 10px auto;
    width: 200px;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 345px;
    }
  }
  .off-text {
    font-size: '68px';
    line-height: '1.4';
    font-weight: 'none';
    margin-top: -30px;
  }

  .starSize {
    font-size: 50%;
  }

  .super-text {
    > span {
      line-height: ${(props) => props.theme.typography.fontSizes.fs18};
      vertical-align: top;
      padding-top: 15px;
      display: inline-block;
    }
  }
  .get-text,
  .ten-text {
    font-size: 66px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 44px;
    }
  }
  .first-text {
    display: inline-block;
    font-size: 44px;
    line-height: 54px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: 54px;
      line-height: 66px;
      margin-top: 32px;
    }
  }
  .know-text {
    display: inline-block;
    font-size: 56px;
    line-height: 68px;
    position: relative;
    @media ${(props) => props.theme.mediaQuery.medium} {
      font-size: 70px;
      line-height: 86px;
      margin-top: -15px;
    }
  }
  .flash-text {
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-right: 3px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: 0;
      margin-right: 0px;
    }
  }
  .dollar-text {
    vertical-align: top;
    line-height: 66px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 0px 0 4px;
    .offer-type__label {
      ::after {
        margin-bottom: 0;
      }
    }
  }
  .sign-up__label {
    display: none;
  }
  ${(props) =>
    props.noModal &&
    `
    #sign-up-modal-form-intro-view {
      padding-top: ${props.isSNJBrand ? '0px' : '32px'};
    }
  `}
`;
